/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Test_SuccessInputs */



/**
* | output |
* | --- |
* | "Live captioning connection test succeeded." |
*
* @param {Live_Caption_Test_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_test_success = /** @type {((inputs?: Live_Caption_Test_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Test_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Test de connexion au sous-titrage en direct réussi.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Verbindungstest für die Live-Untertitelung war erfolgreich.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Test di connessione per i sottotitoli in tempo reale riuscito.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Проверка подключения для трансляции субтитров в реальном времени прошла успешно.")
	if (locale === "es") return /** @type {LocalizedString} */ ("La prueba de conexión para subtítulos en directo se ha realizado correctamente.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("实时字幕连接测试成功。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ライブ字幕接続テストに成功しました。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लाइव कैप्शनिंग कनेक्शन परीक्षण सफल रहा।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O teste de conexão de legendas ao vivo foi bem-sucedido.")
	return /** @type {LocalizedString} */ ("Live captioning connection test succeeded.")
});